/* eslint-disable */
import { v4 as uuidV4 } from 'uuid';
export class FormaPagamento {
  constructor () {
    this.descr= ''
    this.gera_contas_receber= false
  }
}
